import { Grid } from "@mui/material"
import ringsIcon from '../../../assets/icons/ringsIcon.svg'
import { ISettingsItem } from "../../../Settings"
import { useTranslation } from "../../../i18n"

export default function Details({ name, variables }: ISettingsItem) {
  const { t } = useTranslation()
  const { image = [ringsIcon], text = [t.page1.detailsDefault1, t.page1.detailsDefault2] } = variables || {}

  return (
    <Grid container item className={name ? `${name} details` : "details"}>
      <img src={image[0]} alt="Ícone de detalhes" />
      <Grid item className="detailsTextArea">
        <h3>{text[0]}</h3>
        <p>{text[1]}</p>
      </Grid>
    </Grid>
  )
}